import { Box, Container, Stack, Typography } from "@mui/material";

function Hero() {
  return (
    <>
      <Box id="hero">
        <Container sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 4
        }}>
          <Stack spacing={2} useFlexGap sx={{ alignItems: "center" }}>
            <Box
              component="img"
              sx={{
                height: 192,
                width: 192,
                objectFit: "cover",
                borderRadius: "20px",
                filter: "drop-shadow(1px 1px 2px rgb(0 0 0 / 0.2))"
              }}
              alt="Lokala Pärlor"
              src="/logo192.png"
            />
            <Typography variant="h3" component="h1">Lokala Pärlor</Typography>
          </Stack>
        </Container>
      </ Box>
    </>
  );
}

export default Hero;
